import { v4 as uuid } from "uuid";
import DossierAPI from "@/api/DossierAPI";
import WPAPI from "@/api/WPAPI";

import { createSlice, current, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {SCHEDULE} from "@/actions/globalConst";
import { useParams, useNavigate, useLocation, Navigate } from "react-router-dom";

import moment from 'moment';
import CalenderHelperClass from '@/helpers/CalenderHelper'
import StorageHelperClass, {STORAGE} from '@/helpers/StorageHelper'
import {TaskScheduleModel} from '@/models/TaskSchedule';

import { ModalModel } from "@/models/Modal";

export const MODAL_TYPE = {
    "REMOVE_USERTASKITEM" : "REMOVE_USERTASKITEM",
    "COMPLEET_PLANBOARDTASKS" : "COMPLEET_PLANBOARDTASKS",        
}    


export const initialState = {
    modals: new ModalModel(),
    current: null,
    key: null
}
/*
 {
    modals: new ModalModel(),
    modalSelected: {},
    key: "",
    error: null
};
*/
const rejectEventHandlerSchedule=((state, action) => {
    state.apiState = SCHEDULE.API_READY;
    state.error = action.payload;
    state.key = uuid().slice(0, 8);

});
const pendingEventHandlerSchedule=((state, action) => {
    state.apiState = SCHEDULE.API_PROCESSING;
    state.key = uuid().slice(0, 8);
    
})
let fullFilledEventHandlerSchedule= ( (state, action) => {
    //;
    state.apiState = SCHEDULE.API_READY;
    state.key = uuid().slice(0, 8);
    state.error = null;
    return state;
})
let task = null;
const ModalReducerClass = createSlice({
  name: 'ModalReducer',
  initialState,
  reducers: {
      show:  ((state = null, action = null) => {
                
                if(action.payload.modalType) {
                    switch(action.payload.modalType) {
                        case MODAL_TYPE.REMOVE_USERTASKITEM:
                            let modalObj = state.modals.create(action.payload.modalType, action.payload.data, action.payload.options);
                            state.current = modalObj; 
                            break;

                        case MODAL_TYPE.COMPLEET_PLANBOARDTASKS:
                            let modalObj2 = state.modals.create(action.payload.modalType, action.payload.data, action.payload.options);
                            state.current = modalObj2; 
                            break;
                            
                            
                    }
                }
                state.key = uuid().slice(0, 8);
                
//              state.key = uuid().slice(0, 8);
 //             state.error = null;
              return state;
        }),
      hide:  ((state = null, action = null) => {
//          
              state.current = null;
              state.key = uuid().slice(0, 8);
              state.error = null;
              return state;
        })
        
  },
  extraReducers(builder) {
//    task = saveScheduleTasks2;
//    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandlerSchedule(state, action)).addCase(task.rejected, (state, action) => rejectEventHandlerSchedule(state, action)).addCase(task.pending, (state, action) => pendingEventHandlerSchedule(state, action));

    builder.addMatcher(
      (action) => action.type == "switchtenant/pending",
      (state, action) => {

        state = initialState;
       })
       
             
    
  }
  })


export const { show, hide } = ModalReducerClass.actions;
export default ModalReducerClass.reducer